// Owner in P2: piece 18 "Admin part 2 and /personvern" (docs/FILE-OWNERSHIP.md). The public notice page: bare routes
// outside the session check (docs/CONTRACTS.md sections 20.9 and 21.7). `/personvern` is the page; `/notice` only
// redirects there. No rail entry.
import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'
import type { Feature } from '../feature.ts'

export const feature: Feature = {
  bare: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/personvern', component: lazyRouteComponent(() => import('./NoticeScreen.tsx')) }),
    createRoute({
      getParentRoute: () => parent,
      path: '/notice',
      beforeLoad: () => {
        throw redirect({ to: '/personvern', replace: true })
      },
    }),
  ],
  nav: [],
}
